import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminPlatformSale = () => (
  <AdminServiceTickets
    serviceCode="sales"
    title="Relation client"
    lead="Les demandes liées au module de relation client de Gestion 360."
  />
);

export default AdminPlatformSale;
